import { create } from 'zustand'

export interface FlyAnimationState {
  active: boolean
  startX: number
  startY: number
  endX: number
  endY: number
  productImage: string
  id: string
}

interface CartAnimationState {
  /** Currently active fly-to-cart animation (if any) */
  fly: FlyAnimationState | null
  /** Trigger a fly-to-cart animation */
  triggerFly: (params: Omit<FlyAnimationState, 'active'>) => void
  /** Clear the fly animation state */
  clearFly: () => void
  /** Cart icon bounce key — increments on each add to trigger CSS animation */
  cartBounceKey: number
  /** Increment cart bounce key */
  bounceCart: () => void
}

let flyCounter = 0

export const useCartAnimationStore = create<CartAnimationState>((set) => ({
  fly: null,
  cartBounceKey: 0,

  triggerFly: (params) => {
    flyCounter++
    set({
      fly: { ...params, active: true, id: `fly-${flyCounter}` },
    })
    // Auto-clear after animation completes (700ms)
    setTimeout(() => {
      set({ fly: null })
    }, 750)
  },

  clearFly: () => {
    set({ fly: null })
  },

  bounceCart: () => {
    set((state) => ({ cartBounceKey: state.cartBounceKey + 1 }))
  },
}))
